import SalesOptions from './SalesOptions'
import SubMenu from '../common/SubMenu'

const Sales = () => (
    <SubMenu componentOptions={SalesOptions} />
)

export default Sales